import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { customerApi, setCustomerToken } from "@/lib/customerApi";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const CustomerCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const processed = useRef(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = location.hash || window.location.hash;
        // Conserva eventuale codice tavolo passato come query string (?t=TAV-...)
        const params = new URLSearchParams(location.search || window.location.search);
        const tableCode = (params.get("t") || "").trim();
        const targetUrl = tableCode ? `/c?t=${encodeURIComponent(tableCode)}` : "/c";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            setError("Token mancante");
            setTimeout(() => navigate(targetUrl, { replace: true }), 2000);
            return;
        }
        (async () => {
            try {
                const { data } = await customerApi.post("/customer/auth/google-session", {
                    session_id: decodeURIComponent(m[1]),
                });
                setCustomerToken(data.token);
                window.history.replaceState({}, document.title, targetUrl);
                navigate(targetUrl, { replace: true });
            } catch (e) {
                setError(e?.response?.data?.detail || "Errore di accesso");
                setTimeout(() => navigate(targetUrl, { replace: true }), 4000);
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="min-h-screen bg-deep flex items-center justify-center text-warm">
            <div className="text-center max-w-md px-6">
                {!error ? (
                    <>
                        <Loader2 className="w-10 h-10 text-brand animate-spin mx-auto mb-4" />
                        <div className="font-display text-xl font-bold mb-2">Accesso in corso...</div>
                    </>
                ) : (
                    <>
                        <div className="text-red-400 font-display text-xl font-bold mb-2">Errore</div>
                        <div className="text-elegant text-sm">{error}</div>
                    </>
                )}
            </div>
        </div>
    );
};

export default CustomerCallback;
